/**
 * @description {博客文章 相关接口 }
 */
import { api } from '@/utils/http'

const ARTICLE_LIST = '/article/list'
const ARTICLE_ADD = '/article/add'
const ARTICLE_UPDATE = '/article/update'
const ARTICLE_DEL = '/article/del'
const ARTICLE_TREE = '/article/tree'
const ARTICLE_QUERY = '/article/query'
const ARTICLE_HIT = '/article/hit'

export function articleList(data){
    return api({url:ARTICLE_LIST, method:'POST', data})
}

export function articleAdd(data){
    return api({url:ARTICLE_ADD, method:'POST', data})
}

export function articleUpdate(data){
    return api({url:ARTICLE_UPDATE, method:'POST', data})
}

export function articleDel(data){
    return api({url:ARTICLE_DEL, method:'POST', data})
}

export function articleTree(data){
    return api({url:ARTICLE_TREE, method:'POST', data})
}

export function articleQuery(data){
    return api({url:ARTICLE_QUERY, method:'POST', data})
}

export function articleHit(data){
    return api({url:ARTICLE_HIT, method:'POST', data})
}
